<template>
  <div class="pay-box" ref="payBox">
    <div class="title">
      <div class="left">
        <span class="text1">实习生管理</span>
      </div>
    </div>
    <div style="min-height: 500px;background: #fff;">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;height: 100%"
        :header-cell-style="{background: '#00a2ea',color: '#fff;'}"
        header-cell-class-name="tab-head"
      >
        <el-table-column
          prop="user_real_name"
          label="姓名"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: #00a2ea">{{scope.row.user_real_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="jobs_name"
          label="职位名称"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: #00a2ea;">{{scope.row.jobs_name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="简历"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="cursor: pointer;" @click="toResume(scope.row.resume_id,scope.row.jobs_id)">简历详情</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预存工资"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.wage_status === 0" class="item-btn active" @click="Visible1=true,setId=scope.row.id">预存</span>
            <span v-else class="item-btn">预存</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="prestore_reality_wage"
          label="预存金额"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.prestore_reality_wage}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发放"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.wage_status === 1" class="item-btn active"
                  @click="Visible2=true,setId=scope.row.id,memberId=scope.row.candidate_user_id">发放</span>
            <span v-else class="item-btn">发放</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.wage_status === 1" class="item-btn active" @click="Visible3=true,setId=scope.row.id">
              退回预存款
            </span>
            <span v-else class="item-btn">
              退回预存款
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="发放记录"
          align="center"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #00a2ea;cursor: pointer;"
                  @click="showList(scope.row.candidate_user_id,scope.row.jobs_id)">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="Number(pageNum)"
      :page-size="pageSize"
      :prev-text="pageText.prevText"
      :next-text="pageText.nextText"
      layout="prev, pager, next, jumper"
      :total="pageTotal"
      v-if="tableData.length !== 0">
    </el-pagination>
    <el-dialog custom-class="Visible" append-to-body :close-on-click-modal="false" :visible.sync="Visible1">
      <div class="dialogBox">
        <div class="title">预存</div>

        <p class="account">金额</p>
        <el-input placeholder="请输入要预存的金额数" v-model="payYucun" class="pay-input">
          <template slot="append">元</template>
        </el-input>
        <div class="pay-list">
          <span @click="payMode=1" :class="{active:payMode===1}">余额 <i class="iconfont iconxuanzhong"></i></span>
          <span @click="payMode=2" :class="{active:payMode===2}">微信 <i class="iconfont iconxuanzhong"></i></span>
          <span @click="payMode=3" :class="{active:payMode===3}">支付宝 <i class="iconfont iconxuanzhong"></i></span>
          <span @click="payMode=4" :class="{active:payMode===4}">对公转账 <i class="iconfont iconxuanzhong"></i></span>
        </div>
        <div>
          <div v-show="payMode===1">
            您的剩余余额为：{{myPay}}元
          </div>
          <div v-show="payMode===2">

          </div>
          <div v-show="payMode===3">

          </div>
          <div v-show="payMode===4">
            <p class="account">对公转账信息</p>
            <p class="pay-info">账户名称：{{shoukuan.name}}</p>
            <p class="pay-info">银行卡号：{{shoukuan.num}}</p>
            <p class="pay-info">开户行：{{shoukuan.addr}}</p>
            <div style="border-top: 1px solid  #ddd;margin-top: 20px;padding: 20px 0; ">
              <p class="account">填写转账信息</p>
              <el-form ref="form" :model="payForm" :rules="rules" label-width="100px">
                <el-form-item label="账户名称" prop="name">
                  <el-input v-model="payForm.name" placeholder="请输入账户名称"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号" prop="num">
                  <el-input v-model="payForm.num" placeholder="请输入银行卡号"></el-input>
                </el-form-item>
                <el-form-item label="开户行" prop="addr">
                  <el-input v-model="payForm.addr" placeholder="请输入开户行"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <el-button class="btn" type="primary" @click="submut1">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog custom-class="Visible" append-to-body :close-on-click-modal="false" :visible.sync="Visible2">
      <div class="dialogBox">
        <div class="title">发放</div>
        <p class="account">金额</p>
        <el-input type="Number" placeholder="请输入要月工资金额数" v-model="payFafang" class="pay-input">
          <template slot="append">元</template>
        </el-input>
        <el-button class="btn" type="primary" @click="submut2">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog custom-class="Visible" append-to-body :close-on-click-modal="false" :visible.sync="Visible3">
      <div class="dialogBox">
        <div class="title">退回</div>
        <p class="account">金额</p>
        <el-input placeholder="请输入要退回的原因" type="textarea" rows="4" v-model="payTuihui" class="pay-input">
          <template slot="append">元</template>
        </el-input>
        <el-button class="btn" type="primary" @click="submut3">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog custom-class="Visible" append-to-body :close-on-click-modal="false" :visible.sync="Visible4">
      <div class="dialogBox">
        <div class="title">发放记录</div>
        <el-table
          :data="fafangData"
          tooltip-effect="dark"
          style="width: 100%;"
          height="500"
          :header-cell-style="{background: '#f2f3f5',
    color: '#000;'}"
        >
          <el-table-column
            prop="pay_time"
            label="发放时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.pay_time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reality_pay_wage"
            label="发放金额"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.reality_pay_wage}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog custom-class="Visible" append-to-body :close-on-click-modal="false" :visible.sync="Visible5">
      <div class="dialogBox">
        <div class="title">微信支付</div>
        <div class="wx-code">
          <div id="qrcode" ref="qrcode" style="width: 300px;margin: 0 auto;"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from '../../config/index'
  import QRcode from 'qrcodejs2'

  export default {
    data() {
      return {
        tableData: [],
        fafangData: [],
        pageNum: 1,
        pageSize: 10,
        pageTotal: 1,
        pageText: {
          prevText: '<上一页',
          nextText: '下一页>'
        },
        setId: '',        //  当前操作条的id
        memberId: '',      //  发放人的id
        Visible1: false,
        Visible2: false,
        Visible3: false,
        Visible4: false,
        Visible5: false,
        timer: null,
        payMode: 1,
        myPay: '',        //  我的钱
        payYucun: '',    //  预存金额
        payFafang: '',   //  发放金额
        payTuihui: '',   //  退回原因
        shoukuan: {      //  收款方信息
          name: '',
          num: '',
          addr: ''
        },
        payForm: {        //  对公转账表单
          name: '',
          num: '',
          addr: ''
        },
        rules: {
          name: [
            {required: true, message: '请输入账户名称', trigger: 'blur'}
          ],
          num: [
            {required: true, message: '请输入银行卡号', trigger: 'blur'}
          ],
          addr: [
            {required: true, message: '请输入开户行', trigger: 'blur'}
          ],
        }
      }
    },
    created() {
      this.init()
      this.getPay()
    },
    methods: {
      init() {
        if (this.$route.query.pageNum) {
          this.pageNum = this.$route.query.pageNum
        } else {
          this.pageNum = 1
        }
        this.$api.apiOrg.shixiList({
          userToken: this.$store.state.user.user_token,
          page: this.pageNum,
          pageSize: this.pageSize
        }).then(res => {
          let _arr = res.data
          _arr.map(item => {
            item.ual_addtime = this.$tools.ZHDate(new Date(item.ual_addtime * 1000))
          })
          this.tableData = _arr
          this.pageTotal = res.total_number
        }).catch(() => {
          this.tableData = []
        })
        this.$api.apiOrg.transferInfoData({   //  获取收款方信息
          userToken: this.$store.state.user.user_token,
        }).then(res => {
          this.shoukuan.name = res.data.name
          this.shoukuan.num = res.data.card_num
          this.shoukuan.addr = res.data.open_blank
        }).catch(() => {
          this.tableData = []
        })
      },
      toResume(reumeId,jobId){
        this.$router.push({
          path:'/org/resumeDetail',
          query:{
            resumeId:reumeId,
            jobId:jobId
          }
        })
      },
      //  退回
      submut3() {
        this.$api.apiOrg.refund({
          userToken: this.$store.state.user.user_token,
          reason: this.payTuihui,
          id: this.setId
        })
          .then(res => {
            this.Visible3 = false
            this.$message.success(res.info)
            this.init()
          })
          .catch(e => {
            this.$message.error(e.info)
          })
      },
      //  发放
      submut2() {
        this.$api.apiOrg.payOff({
          userToken: this.$store.state.user.user_token,
          reality_pay_wage: this.payFafang,
          candidate_user_id: this.memberId,
          id: this.setId
        })
          .then(res => {
            this.Visible2 = false
            this.$message.success(res.info)
            this.init()
          })
          .catch(e => {
            this.$message.error(e.info)
          })
      },
      qrcode(url) {
        let qrcode = new QRcode('qrcode', {
          width: 300, // 设置宽度，单位像素
          height: 300, // 设置高度，单位像素
          text: url   // 设置二维码内容或跳转地址
        })
        console.log(qrcode)
      },
      //  预存
      submut1() {
        if (this.payYucun < 10) {
          this.$message.error('至少预存金额为10元')
          return;
        }
        if (this.payMode === 1) {
          this.$api.apiOrg.balancePayAdvanceCharge({
            userToken: this.$store.state.user.user_token,
            money: this.payYucun,
            type: 2,
            userMyJobId: this.setId
          })
            .then(res => {
              this.Visible1 = false
              this.$message.success(res.info)
              this.init()
              this.payYucun = ''
              this.getPay()
            })
            .catch(e => {
              this.$message.error(e.info)
            })
        } else if (this.payMode === 2) {
          this.$api.apiOrg.wxPay({
            userToken: this.$store.state.user.user_token,
            money: this.payYucun,
            type: 3
          }).then(res => {
            this.Visible1 = false
            this.Visible5 = true
            this.$nextTick(() => {
              this.qrcode(res.data.wechatCode)
            })
            this.orderId = res.data.orderId
            this.timer = setInterval(() => {
              this.$api.apiOrg.checkOrderPayState({
                userToken: this.$store.state.user.user_token,
                orderId: this.orderId
              }).then(() => {
                window.clearInterval(this.timer)
                this.timer = null
                this.$message.success('支付成功')
                this.Visible5 = false
                this.init()
              }).catch(() => {

              })
            }, 5000)
          }).catch(e => {
            this.$message.error(e.info)
          })
        } else if (this.payMode === 3) {
          window.location.href = config.urlStr + '/index/Account/AlipayRecharge?userToken=' + this.$store.state.user.user_token + '&money=' + this.payYucun + '&type=2&userMyJobId=' + this.setId
        } else if (this.payMode === 4) {
          this.$refs.form.validate((valid) => {
            if (valid) {
              this.$api.apiOrg.transferResult({
                userToken: this.$store.state.user.user_token,
                money: this.payYucun,
                cardName: this.payForm.name,
                cardNum: this.payForm.num,
                blankAddress: this.payForm.addr,
                type: 2,
                userMyJobId: this.setId
              })
                .then(res => {
                  this.Visible1 = false
                  this.$message.success(res.info)
                  this.init()
                  this.payYucun = ''
                })
                .catch(e => {
                  this.$message.error(e.info)
                })
            } else {
              return false;
            }
          });

        }
      },
      //  获取我的金额
      getPay() {
        this.$api.apiMember.myPay({
          userToken: this.$store.state.user.user_token,
        }).then(res => {
          this.myPay = Number(res.data.ua_price)
        }).catch(() => {
          this.myPay = 0
        })
      },
      // 发放记录
      showList(id, id2) {  //  候选人id  职位id

        this.$api.apiOrg.releaserecords({
          userToken: this.$store.state.user.user_token,
          candidate_user_id: id,
          jobs_id: id2
        })
          .then(res => {
            res.data.map(item =>{
              item.pay_time = this.$tools.ZHDate(new Date(item.pay_time*1000),1)
            })
            this.fafangData = res.data
            this.Visible4 = true
          })
          .catch(e => {
            this.$message.error(e.info)
          })
      },
      // 分页
      handleSizeChange(val) {
        this.pageNum = val
      },
      handleCurrentChange(val) {
        this.pageNum = val
      },
      setPath(val) {
        this.$router.replace({
          path: '/home/pay',
          query: {
            pageNum: val,
          }
        })
      }
    },
    watch: {
      Visible5() {
        if (!this.Visible3) {
          this.$refs.qrcode.innerHTML = ""
          window.clearInterval(this.timer)
          this.timer = null
        }
      },
      pageNum() {
        this.setPath(this.pageNum, this.type)
      },
      '$route': 'init'
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  .pay-box {

    width: 1200px;
    height: 100%;
    margin: 0 auto 20px;
    background: rgba(244, 246, 249, 1);
    overflow: hidden;

    .title {
      width: 1200px;
      height: 52px;
      margin: 20px auto 20px auto;
      background: #ffffff;
      border-bottom: 4px #00a2ea solid;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        .text1 {
          font-size: 16px;
          color: #333333;
          margin-left: 55px;
          display: block;
          margin-right: 20px;
        }
      }

    }

    .item-btn {
      padding: 5px 10px;
      color: #fff;
      cursor: pointer;
      background: #999;
      border-radius: 6px;

      &.active {
        background: #00a2ea;
      }
    }
  }

  .dialogBox {
    .title {
      font-size: 30px;
      text-align: center;
      margin-bottom: 20px;
    }

    .account {
      font-size: 16px;
      line-height: 32px;
      margin-bottom: 10px;
    }

    .pay-input {
      margin-bottom: 20px;
    }

    .pay-list {
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 20px;
      margin-bottom: 20px;

      span {
        display: block;
        width: 45%;
        height: 40px;
        border: 1px solid #ddd;
        border-radius: 6px;
        margin: 10px 0;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        i {
          display: none;
          position: absolute;
          right: -1px;
          bottom: -12px;
          font-size: 16px;
        }

        &.active {
          border: 1px solid #00a2ea;
          color: #00a2ea;

          i {
            display: block;
            color: #00a2ea;
          }
        }
      }
    }

    .pay-info {
      line-height: 32px;
    }

    .btn {
      width: 450px;
      height: 50px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #00a2ea;
      border-radius: 0;
      border: none;
      color: #ffffff;
    }
  }
</style>